import { env } from '@/config/env'
import { setAuthorizationProvider } from '@/services/http'
import { getTelegramInitDataRaw, initTelegram } from '@/telegram'

/**
 * Runs before the first render. Order matters: the mock must exist before the SDK reads
 * launch params, and the auth provider must be set before any request is sent.
 */
export async function bootstrapApplication(): Promise<void> {
  // `import.meta.env.DEV` is a build-time constant, so the mock module is removed from production bundles.
  if (import.meta.env.DEV && env.isTelegramMockEnabled) {
    const { mockTelegramEnvironment } = await import('@/telegram/mock')
    await mockTelegramEnvironment()
  }

  await initTelegram({ isDebugEnabled: env.isDebugEnabled })

  // Convention for Telegram Mini Apps: `Authorization: tma <initDataRaw>`.
  // The backend must verify the signature with the bot token before trusting it.
  setAuthorizationProvider(() => {
    const initDataRaw = getTelegramInitDataRaw()
    return initDataRaw ? `tma ${initDataRaw}` : undefined
  })
}
